var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('br'),_c('br'),_vm._v(" "),_c('a-table',{attrs:{"columns":_vm.columns,"data-source":_vm.data},scopedSlots:_vm._u([{key:"action",fn:function(text,record){return _c('a',{on:{"click":function($event){return _vm.handleEdit(record.name)}}},[_vm._v("编辑")])}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1016c7ce","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VersionList.vue
// module id = null
// module chunks = 